var r = Object.defineProperty;
var e = (o, t) => r(o, "name", { value: t, configurable: !0 });

// src/component-testing/preview.ts
import { definePreviewAddon as p } from "storybook/internal/csf";
import { instrument as a } from "storybook/internal/instrumenter";
var { step: i } = a(
  {
    // It seems like the label is unused, but the instrumenter has access to it
    // The context will be bounded later in StoryRender, so that the user can write just:
    // await step("label", (context) => {
    //   // labeled step
    // });
    step: /* @__PURE__ */ e(async (o, t, n) => t(n), "step")
  },
  { intercept: !0 }
), m = /* @__PURE__ */ e(() => p({
  parameters: {
    throwPlayFunctionExceptions: !1
  },
  runStep: i
}), "default");
export {
  m as default
};
